import React, { useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import EcoIcon from "@material-ui/icons/Eco";
import SyncIcon from "@material-ui/icons/Sync";
import { useStyles } from "./projectItem.styles";
import Counter from "../counter/counter";
import ProjectItemLogic from "./projectItem.logic";

const { ProjectItemService } = require("./projectItem.module");

const ProjectItem = (props) => {
  const classes = useStyles();
  const service = ProjectItemService();
  const {
    values,
    handleSubtract,
    handleRadioChange,
    handleAdd,
    // translator,
  } = ProjectItemLogic(props, service.getCommissionByType);

 
  useEffect(() => {
    if (props.onValuesChange) {
      props.onValuesChange({
        price: values.price,
        counter: values.counter,
        fee: values.fee,
        total: values.total,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.price, values.counter, values.fee, values.total]);

  return (
    <Box className={classes.projectCard}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm="auto">
          <Box className={classes.imageContainer}>
            <img
              src={values.project.main_image}
              alt={values.project.info?.en?.name}
              className={classes.projectImage}
            />
            <Box className={classes.verifiedBadge}>VERIFIED</Box>
          </Box>
        </Grid>

        <Grid item xs={12} sm>
          <Typography className={classes.premiumLabel}>
            PREMIUM PROJECT
          </Typography>

          <Typography className={classes.projectTitle}>
            {values.project.info?.en?.name?.toUpperCase()}
          </Typography>

          <Box className={classes.locationRow}>
            <LocationOnIcon className={classes.locationIcon} />
            <Typography className={classes.locationText}>
              {values.project.region}, {values.project.country}
            </Typography>
          </Box>

          <Box className={classes.typeButtonsContainer}>
            <FormControl component="fieldset" className={classes.formControl}>
              <RadioGroup
                row
                aria-label="credit_type"
                name="credit"
                value={values.type}
                onChange={handleRadioChange}
                className={classes.radioGroup}
              >
                {values.project.is_available_for_nft && (
                  <FormControlLabel
                    value="buy_nft"
                    control={<Radio className={classes.hiddenRadio} />}
                    label={
                      <Button
                        className={
                          values.type === "buy_nft"
                            ? classes.typeButtonActive
                            : classes.typeButtonInactive
                        }
                        startIcon={<EcoIcon />}
                      >
                        Carbon Credit
                      </Button>
                    }
                    className={classes.formControlLabel}
                  />
                )}

                <FormControlLabel
                  value="buy_sbt"
                  disabled={!values.project.is_available_for_sbt}
                  control={<Radio className={classes.hiddenRadio} />}
                  label={
                    <Button
                      className={
                        values.type === "buy_sbt"
                          ? classes.typeButtonActive
                          : classes.typeButtonInactive
                      }
                      startIcon={<SyncIcon />}
                      disabled={!values.project.is_available_for_sbt}
                    >
                      Carbon Offset
                    </Button>
                  }
                  className={classes.formControlLabel}
                />
              </RadioGroup>
            </FormControl>
          </Box>
        </Grid>
      </Grid>

      <Box className={classes.quantitySelectorSection}>
        <Typography className={classes.quantityLabel}>
          Select Amount (Metric Tons)
        </Typography>

        <Counter
          type="investment"
          increment={handleAdd}
          decrement={handleSubtract}
          counter={values.counter}
        />
      </Box>
    </Box>
  );
};

export default ProjectItem;
